import React from "react"

const Layout = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>
}

export default Layout
